import createStore from "APP_ROOT/createStore";

export default function useRejectedCore() {
  return createStore()
    .getState()
    .rejectedCoreDetail.get("rejectedCore")
    .toJS();
}



// WEBPACK FOOTER //
// ./app/hooks/useRejectedCore.js